import React from "react";
import Reveal from "@/components/Reveal";

const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_christopher-magician/artifacts/y2xn3pwk_1326.jpg";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative pt-14 md:pt-20 lg:pt-24 pb-14 md:pb-20 lg:pb-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        {/* Section heading */}
        <div className="flex items-center gap-4 mb-16">
          <span className="overline">01 — The Magician</span>
          <span className="gold-rule" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Text Column */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <Reveal>
              <h2
                data-testid="about-headline"
                className="font-display text-[#F5F5F0] text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight"
              >
                A craftsman of impossible
                <span className="font-italic-display text-[#C5A059]">
                  {" "}
                  moments
                </span>
                .
              </h2>
            </Reveal>

            <Reveal delay={1}>
              <p
                data-testid="about-paragraph-1"
                className="mt-10 text-[#A1A1AA] text-base md:text-lg leading-[1.85] max-w-xl"
              >
                With over two decades of experience, Chris DePamphilis has
                honed his craft on international stages, from the bustling
                streets of Tokyo and Osaka, Japan to his acclaimed three-week
                residency, &ldquo;The Devil You Don&rsquo;t&rdquo; was
                featured in the Greenbelt Arts Center 2023&ndash;2024 season.
              </p>
            </Reveal>

            <Reveal delay={2}>
              <p
                data-testid="about-paragraph-2"
                className="mt-6 text-[#A1A1AA] text-base md:text-lg leading-[1.85] max-w-xl"
              >
                As a repeat headliner at Virginia&rsquo;s &ldquo;Magic
                Mic&rdquo;, Maximum Magic Live, and a featured house magician
                at Baltimore&rsquo;s &ldquo;Poe&rsquo;s Magic Theatre,&rdquo;
                Chris&rsquo;s unique blend of masterful sleight-of-hand, and
                engaging stage presence will leave you amazed. Audiences are
                always amazed by a magician who doesn&rsquo;t just perform
                magic effects but creates an unforgettable experience that
                will challenge your perception of reality.
              </p>
            </Reveal>

            {/* Quote */}
            <Reveal delay={3}>
              <blockquote
                data-testid="about-quote"
                className="mt-12 border-l border-[#C5A059]/40 pl-8 max-w-xl"
              >
                <p className="font-italic-display text-2xl md:text-3xl text-[#F5F5F0] leading-snug">
                  &ldquo;I am not interested in fooling you. I am interested
                  in making you remember what wonder felt like.&rdquo;
                </p>
                <footer className="mt-5 overline text-[#C5A059]">
                  — Christopher
                </footer>
              </blockquote>
            </Reveal>
          </div>

          {/* Portrait Column */}
          <div className="lg:col-span-5 order-1 lg:order-2 lg:sticky lg:top-28">
            <Reveal>
              <div className="relative img-hover">
                {/* Decorative frame */}
                <span
                  aria-hidden
                  className="absolute -top-3 -left-3 w-16 h-16 border-t border-l border-[#C5A059]"
                />
                <span
                  aria-hidden
                  className="absolute -bottom-3 -right-3 w-16 h-16 border-b border-r border-[#C5A059]"
                />
                <img
                  data-testid="about-portrait"
                  src={PORTRAIT}
                  alt="Portrait of Christopher DePamphilis"
                  className="w-full h-[520px] md:h-[640px] object-cover"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
